import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    verifyPasswordApi, // --- FIX: Import the missing API function ---
    requestOtpApi,
    verifyOtpApi,
    forgotPassword,
    resetPassword
} from "../../../Services/API";

// --- FIX: Create the missing loginSlice for email/password login ---
export const loginSlice = createAsyncThunk(
    "auth/login",
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await verifyPasswordApi(credentials);
            // Return the data part of the response on success
            return response.data;
        } catch (error) {
            // Use rejectWithValue to pass the server's error response to the reducer
            return rejectWithValue(error.response.data);
        }
    }
);

// user login  Slice
export const requestOtpSlice = createAsyncThunk("requestOtp", async (data) => {
    try {
        const response = await requestOtpApi(data);
        return response
    } catch (error) {
        throw error;
    }
});
export const verifyOtpSlice = createAsyncThunk("verifyOtp", async (data) => {
    try {
        const response = await verifyOtpApi(data);
        return response
    } catch (error) {
        throw error;
    }
});
export const forgetPasswordSlice = createAsyncThunk("forgetPasswordSlice", async (data) => {
    try {
        const response = await forgotPassword(data);
        return response
    } catch (error) {
        throw error;
    }
});
// deprecated for OTP
export const resetPasswordSlice = createAsyncThunk("resetPasswordSlice", async (data) => {
    try {
        const response = await resetPassword(data);
        return response
    } catch (error) {
        throw error;
    }
});

const initialState = {
    otpRequested: false,
    otpVerified: false,
    userlogindetail: [],
    userData: [],
    loading: false,
    error: null
};

export const AuthSlice = createSlice({
    name: "AuthSlice",
    initialState,
    extraReducers: (builder) => {
        // --- FIX: Add the reducers for the new loginSlice ---
        builder.addCase(loginSlice.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(loginSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.userlogindetail = action.payload; // Store user data and token
            })
            .addCase(loginSlice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message from the server
            });

        // Request OTP flow
        builder.addCase(requestOtpSlice.pending, (state) => {
            state.loading = true;
            state.otpRequested = false;
        })
            .addCase(requestOtpSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.otpRequested = true;
            })
            .addCase(requestOtpSlice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // Verify OTP flow
        builder.addCase(verifyOtpSlice.pending, (state) => {
            state.loading = true;
            state.otpVerified = false;
        })
            .addCase(verifyOtpSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.otpVerified = true;
                state.userlogindetail = action.payload;
            })
            .addCase(verifyOtpSlice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default AuthSlice.reducer;
